<div class="tile-header">
  <span class="tile-label">Total</span>
</div>
@if (loading()) {
  <div class="skeleton-line short"></div>
} @else {
  <div class="tile-value-row">
    <span class="tile-value">{{ value() }}</span>
  </div>
}
